import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

/**
 * startApp function created to resolve sonar issue -> Prefer top-level await over an async function `bootstrap` call.
*/
function startApp() {
  bootstrapApplication(AppComponent, appConfig).catch((error) => {
    throw error;
  });
}
startApp();
